import type { InsuranceCarrier } from "@/core/types";
import type { InsuranceListResponse } from "@/features/insurance/types";
import type { SelectOption } from "@/ui2/types";

/**
 * Merges system carriers with any accepted_insurance entries
 * absent from the system list into a single SelectOption array.
 */
export function adaptProviderInsuranceOptions(
  data: InsuranceListResponse,
  acceptedInsurance: InsuranceCarrier[],
): SelectOption<InsuranceCarrier>[] {
  const options: SelectOption<InsuranceCarrier>[] = data.carriers.map((c) => ({
    label: c,
    value: c,
  }));

  acceptedInsurance.forEach((ai) => {
    if (!data.carriers.includes(ai)) options.push({ label: ai, value: ai });
  });

  return options;
}
